/** Email поддержки для отображения в ErrorBoundary */
export const SUPPORT_EMAIL = 'support@toive.app';